var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAprovar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64803 14.025L0 7.37698L1.66201 5.71497L6.64803 10.701L17.349 0L19.011 1.66201L6.64803 14.025Z",
    fill: "#206021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprovar);
export default __webpack_public_path__ + "static/media/aprovar.2e3a8f45ed4ad6a61cb4528b9f3c83ff.svg";
export { ForwardRef as ReactComponent };